var blacklistUserAgents = [
    /Seekport Crawler/,
    /TurnitinBot/,
    /MauiBot/,
    /MJ12bot/,
    /AhrefsBot/,
    /Yeti/,
];

var denyUrls = [
    /(.*)\/gpt\/(.*)/,
    /ampproject/,
    /bat.bing.com/,
    /translatoruser-int/,
    /doubleclick.net/,
    /googleadservices.com/,
    /googlesyndication.com/,
    /hotjar.io/,
];

var allowedHosts = [
];

var blacklistErrorMessages = [
];

var blacklistErrorNames = [];

/**
 * beforeSend set additional values on the Sentry event to be logged
 * @param {Object} data - the original Sentry event data to be logged
 */
var beforeSend = function( event, hint ) {
    var userAgent = navigator.userAgent;
    var currentHost = window.location.hostname;

    for ( var hostIndex = 0; hostIndex < allowedHosts.length; hostIndex++ ) {
        if ( !allowedHosts[ hostIndex ].test( currentHost ) ) {
            return null;
        }
    }

    for ( var agentIndex = 0; agentIndex < blacklistUserAgents.length; agentIndex++ ) {
        if ( blacklistUserAgents[ agentIndex ].test( userAgent ) ) {
            return null;
        }
    }

    for ( var nameIndex = 0; nameIndex < blacklistErrorNames.length; nameIndex++ ) {
        if ( blacklistErrorNames[ nameIndex ].test( hint.originalException.name ) ) {
            return null;
        }
    }

    for ( var msgIndex = 0; msgIndex < blacklistErrorMessages.length; msgIndex++ ) {
        if ( blacklistErrorMessages[ msgIndex ].test( hint.originalException.message ) ) {
            return null;
        }
    }

    return event;
};

var config = {
    dsn: window.sentryDSN,
    sampleRate: 1,
    denyUrls: denyUrls,
    beforeSend: beforeSend,
};

export default config;
